import { Button } from '@mui/material';

import { useTranslate } from 'src/locales';

import { useConnectWhatsApp } from '../hooks/useConnectWhatsApp';

interface FacebookLoginButtonProps {
  disabled?: boolean;
  handleFaceBookDeteail: (value: { main_token: string }) => void;
  onClick?: (value: any) => void;
}

export function FacebookLoginButton({
  disabled,
  handleFaceBookDeteail,
  onClick,
}: FacebookLoginButtonProps) {
  const { t } = useTranslate('translation');

  const { connect } = useConnectWhatsApp({
    onSuccess: handleFaceBookDeteail,
    onClick,
  });

  return (
    <Button
      variant="contained"
      sx={{ background: '#50a28a', my: 2 }}
      onClick={connect}
      disabled={disabled}
    >
      {t('SIGN_IN_WITH')} {t('FACEBOOK')}
    </Button>
  );
}
